export default "__VITE_ASSET__Dm3qTGXH__";